// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IActionButtonSchema {
  /** Тип действия **/
  actionType: EActionType;
  /** Ключ для аналитики **/
  analyticsType: string;
  /** Текст, который будет вставлен в поле ввода после нажатия на кнопку; обязательно для типа 'sendMessage' **/
  inputText?: string;
  /** Выбрана ли кнопка; Используется для отображения выбранной настройки периодичности **/
  isSelected?: boolean;
  /** Ссылка на иконку для кнопки слева **/
  leftIcon?: string;
  /** Ссылка по которой надо перейти в случае выбора этого варианта ответа; обязательна для типа 'deeplink' **/
  link?: string;
  /** Ключ, для получения следующего набора кнопок **/
  payload: EPayload;
  /** Ссылка на иконку для кнопки справа **/
  rightIcon?: string;
  /** Текст кнопки **/
  text: string;
}

export enum EActionType {
  /** Скопировать текст кнопки в инпут **/
  'CopyToInput' = 'copyToInput',
  /** Перейти по диплинку (поле link); отправить payload **/
  'Deeplink' = 'deeplink',
  /** Открыть форму оценки **/
  'OpenSurvey' = 'openSurvey',
  /** Отправить payload **/
  'Payload' = 'payload',
  /** Отправить сообщение (поле text); отправить payload после отправки сообщения **/
  'SendMessage' = 'sendMessage',
}
export enum EPayload {
  /** Спросить у автора после редиректа из эксперта **/
  'AskAuthor' = 'askAuthor',
  /** Уточнить согласие пользователя на расширение поисоквых фильтров **/
  'ChallengeUserExtendedSearch' = 'challengeUserExtendedSearch',
  /** Пользователь согласился на расширение поисковых фильтров **/
  'ChallengeUserExtendedSearchAccept' = 'challengeUserExtendedSearchAccept',
  /** Пользователь отказался от расширения поисковых фильтров **/
  'ChallengeUserExtendedSearchReject' = 'challengeUserExtendedSearchReject',
  /** Закончить сценарий консьержа **/
  'CloseConcierge' = 'closeConcierge',
  /** Закрыть чат **/
  'Closing' = 'closing',
  /** Не спрашивать у автора после редиректа из эксперта **/
  'DontAskAuthor' = 'dontAskAuthor',
  /** Перейти в чат с автором объявления **/
  'GoToChat' = 'goToChat',
  /** Базовый набор кнопок **/
  'Initial' = 'initial',
  /** Не менять периодичность **/
  'KeepPeriodicity' = 'keepPeriodicity',
  /** Новый поиск **/
  'NewSearch' = 'newSearch',
  /** Открыть форму оценки **/
  'OpenSurvey' = 'openSurvey',
  /** Периодичность - раз в день **/
  'PeriodDaily' = 'periodDaily',
  /** Периодичность - раз в 3 дня **/
  'PeriodEveryThreeDays' = 'periodEveryThreeDays',
  /** Периодичность - раз в неделю **/
  'PeriodWeekly' = 'periodWeekly',
  /** Оценил бота **/
  'Rate' = 'rate',
  /** Спросил то, чего не знает эксперт бот, но может знать автор **/
  'RedirectToConcierge' = 'redirectToConcierge',
  /** Посмотреть все рекомендации **/
  'SeeAll' = 'seeAll',
  /** Отправить сообщение **/
  'SendMessage' = 'sendMessage',
  /** Отправить сообщение в GPT чтобы начать поиск через него **/
  'SendMessageAndNewSearch' = 'sendMessageAndNewSearch',
  /** Отправить сообщение и предложить начать начать поиск **/
  'SendMessageAndSearch' = 'sendMessageAndSearch',
  /** Отправил сообщение в бота-консьержа **/
  'SendMessageConcierge' = 'sendMessageConcierge',
  /** Отправил сообщение в экспертный бот **/
  'SendMessageExpert' = 'sendMessageExpert',
  /** Пришли еще **/
  'SendMore' = 'sendMore',
  /** Настроить периодичность **/
  'SetupPeriodicity' = 'setupPeriodicity',
  /** Показать все рекомендации по кнопке **/
  'ShowAll' = 'showAll',
  /** Закрыть сценарий похожих объявлений **/
  'SimilarOffersClose' = 'similarOffersClose',
  /** Начать поиск похожих объявлений **/
  'SimilarOffersNewSearch' = 'similarOffersNewSearch',
  /** Прислать еще похожие объявления **/
  'SimilarOffersSendMore' = 'similarOffersSendMore',
  /** Отписаться от CRM рассылки **/
  'StopCrm' = 'stopCrm',
  /** Отписаться от регулярных рекомендаций **/
  'StopRecs' = 'stopRecs',
  /** Подписаться на рассылку **/
  'Subscribe' = 'subscribe',
  /** Синхронизировать сообщения; будет использоваться в будущем для синхронизации сообщений с контекстом GPT **/
  'SyncMessage' = 'syncMessage',
  /** Открытие сценария 'Что ты умеешь?' **/
  'WhatCanYouDo' = 'whatCanYouDo',
  /** Узнать остальные возможности бота **/
  'WhatElseCanYouDo' = 'whatElseCanYouDo',
}
